import styled, { css } from 'styled-components';
import { Colors } from './Colors';

export type TableButtonProps = {
    active?: boolean,
    disabled?: boolean,
    variant?: 'round' | 'square',
};

export const TableButton = styled.div<TableButtonProps>`
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: .1875rem .375rem;
    border-radius: ${p => p.variant === 'round' ? '50rem' : '.375rem'};
    border: solid .0625rem transparent;
    text-align: center;
    user-select: none;
    cursor: pointer;

    &:hover {
        background: ${Colors.hover};
        opacity: 1 !important;
    }
    &:active {
        background: ${Colors.active};
        opacity: 1 !important;
    }
    ${p => p.active && css`
        background: ${Colors.active} !important;
        opacity: 1 !important;
    `}
    ${p => p.disabled && css`
        pointer-events: none;
    `}
`;
